import React, { useEffect, useState } from 'react'
import { useFirstRender } from '../../hooks/useFirstRender'

import ModalContext from './ModalContext'
import ModalHeader from './ModalHeader'
import {
  Backdrop,
  ModalDialog,
  ModalTitle,
  ModalBody,
  ModalFooter,
  ModalContainer
} from './styles'

const Modal = ({
  show,
  onShow,
  onHide,
  onExited,
  size,
  exitOnBackdropClick,
  children,
  variant,
  ...rest
}) => {
  const [active, setActive] = useState(show || false)
  const isFirstRender = useFirstRender()

  useEffect(() => {
    if (show) {
      setActive(true)
      onShow?.()
      return
    }

    if (!isFirstRender) {
      setTimeout(() => {
        setActive(false)
        onExited?.()
      }, 300)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return (
    <ModalContext.Provider value={{ handleOnClose: onHide }}>
      {active && (
        <Backdrop
          show={show}
          onClick={exitOnBackdropClick ? onHide : undefined}
        >
          <ModalDialog
            show={show}
            size={size}
            variant={variant}
            {...rest}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </ModalDialog>
        </Backdrop>
      )}
    </ModalContext.Provider>
  )
}

Modal.defaultProps = {
  exitOnBackdropClick: true
}

export default Object.assign(Modal, {
  Header: ModalHeader,
  Title: ModalTitle,
  Body: ModalBody,
  Footer: ModalFooter,
  Container: ModalContainer
})
